import React from "react";
import ProfileView from "../../../components/sections/front/User/ProfileView";
import DeleteAccount from "../../../components/sections/front/User/DeleteAccount";
import ChangePassword from "../../../components/sections/front/User/ChangePassword";

const UserInfo = () => {
  return (
    <>
      <div className="grid xl:flex items-start gap-8">
        <div className="flex-shrink flex-grow xl:border-r border-md-pink-light-3">
          <ProfileView />
        </div>
        <div className="flex-shrink-0 w-full xl:max-w-md space-y-6">
          <ChangePassword />
          <DeleteAccount />
        </div>
      </div>
    </>
  );
};

export default UserInfo;
